<template>
  <div>
    <b-modal :id="`bv-modal-shipping`" size="lg" hide-footer>
      <template #modal-title>Create shipping label</template>

      <div class="alert alert-danger py-2 mb-1 text-center" role="alert">
        Please make sure you have this product at the collection address before
        creating a shipping label
      </div>

      <div v-if="item" class="mt-3">
        <div class="text-center">
          <div>
            <img
              v-if="item.product.images.length > 0"
              :src="item.product.images[0].url"
              style="height: 4rem" />
            <img
              v-else
              src="/images/image-not-found.svg"
              style="height: 4rem" />
          </div>
        </div>
      </div>

      <div class="row text-center">
        <div class="col">
          <div class="mt-2">
            <b>{{ item.product.name }}</b>
          </div>
          <div>
            R {{ item.product.price * item.quantity }} &bull; Qty
            {{ item.quantity }}
          </div>
        </div>
      </div>

      <div class="row text-center">
        <div class="col">
          <div class="mt-2 rounded head"><b>Collection address</b></div>
          <div class="mt-2">
            <span v-if="address.business_building"
              >{{ address.business_building }},
            </span>
            <span v-if="address.business_unit_number"
              >{{ address.business_unit_number }},
            </span>
            <span v-if="address.business_address"
              >{{ address.business_address }},
            </span>
            <span v-if="address.business_suburb"
              >{{ address.business_suburb }},
            </span>
            <span v-if="address.business_city"
              >{{ address.business_city }},
            </span>
            <span v-if="address.business_province"
              >{{ address.business_province }},
            </span>
            <span v-if="address.business_postal_code">{{
              address.business_postal_code
            }}</span>
          </div>
        </div>
      </div>

      <div class="pt-2">
        <div class="mt-2 text-center rounded head">
          <b>Package dimensions</b>
        </div>
        <div class="row text-center">
          <div class="col-6 col-md-3">
            <label class="form-label pt-2 mb-2">Length (cm)</label>
            <input
              class="form-control2 dimension"
              v-model="item.product.length_cm"
              @keydown="digitsAndDot" 
              maxlength="8" />
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label pt-2 mb-2">Width (cm)</label>
            <input
              class="form-control2 dimension"
              v-model="item.product.width_cm"
              @keydown="digitsAndDot" 
              maxlength="8" />
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label pt-2 mb-2">Height (cm)</label>
            <input
              class="form-control2 dimension"
              v-model="item.product.height_cm"
              @keydown="digitsAndDot" 
              maxlength="8" />
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label pt-2 mb-2">Weight (kg)</label>
            <input
              class="form-control2 dimension"
              v-model="item.product.weight_kg"
              @keydown="digitsAndDot" 
              maxlength="8" />
          </div>
        </div>
      </div>

      <div class="row mt-3 pb-2">
        <div class="col-md-4">
          <button
            type="button"
            class="btn btn-success submit col"
            @click="showModalShippingAddress()">
            Change collection address
          </button>
        </div>
        <div class="col-md-4 mt-2 mt-md-0">
          <button
            type="button"
            class="btn btn-secondary submit col"
            @click="hideModalShippingAddress">
            Cancel
          </button>
        </div>
        <div class="col-md-4 mt-2 mt-md-0">
          <button
            v-if="updating"
            type="button"
            class="btn btn-danger submit col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>
          </button>
          <button
            v-else
            type="button"
            class="btn btn-danger submit col"
            @click="createShippingLabel">
            Create shipping label
          </button>
        </div>
      </div>
    </b-modal>
    <shipping-address-modal></shipping-address-modal>
  </div>
</template> 

<script>
import { EventBus } from "../bus";

export default {
  props: ["item"],
  data() {
    return {
      address: {},
      updating: false,
    };
  },

  created() {
    this.getShippingAddress();

    EventBus.$on("update-address", (product) => {
      this.getShippingAddress();
    });
  },

  methods: {

    showModalShippingAddress() {
      this.$bvModal.show("bv-modal-shipping-address");
    },

    changeShipping() {
      window.location.href = "/sales";
    },

    getShippingAddress() {
      axios.get("/sales/shipping-address").then((response) => {
        this.address = response.data;
      });
    },

    hideModalShippingAddress() {
      this.$bvModal.hide("bv-modal-shipping");
    },

    createShippingLabel() {
      this.item.product.length_cm = Number(this.item.product.length_cm);
      if (isNaN(this.item.product.length_cm)) {
        this.item.product.length_cm = 0;
      }

      this.item.product.width_cm = Number(this.item.product.width_cm);
      if (isNaN(this.item.product.width_cm)) {
        this.item.product.width_cm = 0;
      }

      this.item.product.height_cm = Number(this.item.product.height_cm);
      if (isNaN(this.item.product.height_cm)) {
        this.item.product.height_cm = 0;
      }

      this.item.product.weight_kg = Number(this.item.product.weight_kg);
      if (isNaN(this.item.product.weight_kg)) {
        this.item.product.weight_kg = 0;
      }

      if (this.item.product.length_cm < 1) {
        this.sweetfire("Please enter a package length");
      } else if (this.item.product.width_cm < 0.001) {
        this.sweetfire("Please enter a package width");
      } else if (this.item.product.height_cm < 0.001) {
        this.sweetfire("Please enter a package height");
      } else if (this.item.product.weight_kg < 0.001) {
        this.sweetfire("Please enter a package weight");
      } else {
        this.updating = true;

        axios
          .post("/sales/shipping-label", { item: this.item })
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              this.$emit("update-page");
              this.successAlert(response.data.message);
              this.hideModalShippingAddress();
            } else {
              this.sweetfire(response.data.message);
            }

            this.updating = false;
          });
      }
    },

    // sweet alert for 3 seconds
    successAlert(text) {
      Swal.fire({
        title: text,
        text: "Please check your email for further instructions",
        customClass: {
          title: "popup-title",
          icon: "custom-icon-size",
        },
        icon: "success",
        showConfirmButton: true,
        // timer: 3000,
      });
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },
  },
};
</script>

<style scoped>
textarea.form-control {
  font-size: 0.9rem !important;
}
</style>